import { ToastContainer } from 'react-toastify';
import styled from 'styled-components';
import { getSizeBy, getColor, getElevation } from '../../../src/styled/utils';
import { VIEWPORT_BREAKPOINTS } from '../../../src/styled/global-variables';
import 'react-toastify/dist/ReactToastify.css';
export const MessageWrapper = styled.div `
  display: grid;
  grid-column-gap: ${getSizeBy(3)};
  grid-template-columns: auto 1fr auto;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: ${getSizeBy(3)};
  background-color: ${getColor('surface')};
`;
export const NotificationWrapper = styled(ToastContainer) `
  /* stylelint-disable selector-class-pattern */
  width: 'max-content';
  max-width: 80vw;

  @media screen and (min-width: ${VIEWPORT_BREAKPOINTS.SMALL}px) {
    width: 'max-content';
    max-width: 80vw;
  }

  @media screen and (min-width: ${VIEWPORT_BREAKPOINTS.MEDIUM}px) {
    width: 'max-content';
    max-width: 50vw;
  }

  .Toastify__toast {
    min-height: 44px;
    padding: 0;
    border-radius: ${getSizeBy(2)};
    box-shadow: ${getElevation(8)};
  }

  .Toastify__toast-theme--light,
  .Toastify__toast-theme--colored.Toastify__toast--default {
    background: none;
  }

  .Toastify__toast-body {
    display: flex;
    align-items: stretch;
    margin: 0;
    padding: 0;
  }
`;
